import global from './global/de.json';
import zones from './zones/de.json';

export default {
  global,
  zones
};
